import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product variant's checklist.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class VariantChecklist extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateVariantChecklist);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateVariantChecklist);
  }

  /**
   * Updates the Variant Checklist
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateVariantChecklist = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newVariantChecklist= event.detail.data.html.querySelector('variant-checklist');
 
    const currentVariantChecklist = this;

    if (!newVariantChecklist || !currentVariantChecklist) return;

    if (currentVariantChecklist.innerHTML !== newVariantChecklist.innerHTML) {
      currentVariantChecklist.replaceWith(newVariantChecklist);
    }
  };
}

if (!customElements.get('variant-checklist')) {
  customElements.define('variant-checklist', VariantChecklist);
}
